import {
    Backdrop,
    Box,
    CircularProgress,
    FormControl,
    Grid,
    MenuItem,
    Pagination,
    Select,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Input,
    styled,
    tableCellClasses,
    Typography
} from '@mui/material'
import { BASE_COLOR } from '../../../shared/constants/color.constant'
import { useEffect, useState } from 'react'
import { User } from '../../Utilisateur/interfaces/utilisateur.interface'
import { DateFormater } from '../../../shared/functions/date'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import ModaleValidationComponent from '../../../shared/components/Modale/modale-validation.component'
import accountBlockingServices from '../services/account-blocking.service'
import ModaleValidationDeblocageComponent from '../../../shared/components/Modale/modale-validation-deblocage.component'
import EditIcon from '@mui/icons-material/Edit'
import { CancelOutlined, CheckCircleOutline } from '@mui/icons-material'
import userServices from '../../Utilisateur/services/utilisateur.service'
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: BASE_COLOR.CONTAINER,
        border: 0
    },
    [`& .${tableCellClasses.root}`]: {
        borderBottom: 'none'
    },
    // '&:first-child':{
    //     backgroundColor:'red'
    // }
}))

const StyledTableHeader = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: BASE_COLOR.CONTAINER,
        // fontSize: 15,
        fontWeight: 'bold'
        // textTransform: 'uppercase'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 100,
    },
}))
//     const StyledTableContent = styled(TableCell)(({ theme }) => ({
//     '&:nth-child(4)':{
//         backgroundColor:'red',
//         flex:1,
//     },
// }))

const AccountBlockingComponent: React.FC = () => {
    const [users, setUsers] = useState<User[]>([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [open, setOpen] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [reload, setReload] = useState(0)
    useEffect(() => {
        setLoading(true)
        accountBlockingServices
            .getAllblockedUserAccount(page, rowsPerPage)
            .then(res => setUsers(res.data.data))
            .catch(console.log)
            .finally(() => setLoading(false))
    }, [page, rowsPerPage, reload])

    const handleChangePage = (event: any, newPage: number) => {
        setPage(newPage)
    }

    const [selectedItem, setSelectedItem] = useState<User | null>(null)

    const liftUserSuspension = () => {
        if (selectedItem)
            accountBlockingServices
                .liftSuspension(selectedItem._id)
                .then(() => {
                    setOpen(false)
                    setSelectedItem(null)
                    setReload(prev => ++prev)
                })
                .catch(console.log)
    }

    const [order, setOrder] = useState<'asc' | 'desc'>('asc')
    const [orderBy, setOrderBy] = useState<string>('fullName')

    const handleSort = (property: string) => {
        const isAsc = orderBy === property && order === 'asc'
        const newOrder = isAsc ? 'desc' : 'asc'
        setOrder(newOrder)
        setOrderBy(property)

        const sorted = [...users].sort((a, b) => (newOrder === 'asc' ? handleSortBy(a, b, property) : handleSortBy(b, a, property)))

        setUsers(sorted)
    }

    const handleSortBy = (a: User, b: User, property: string) => {
        switch (property) {
            case 'fullName':
                return `${a['lastname']} ${a['firstname']}`.localeCompare(`${b['lastname']} ${b['firstname']}`)
            default:
                return (a[property] ?? '').localeCompare(b[property])
        }
    }
    const [indiceUpdate, setIndiceUpdate] = useState(-1)
    const [updateAFaire, setUpdateAFaire] = useState(1)
    const handleUpdateWarning = (id: any, accountWarning: number) => {
        userServices
        .updatePresta({
            accountWarning: accountWarning,
            _id: id,
        })
        .catch(console.log)
        .finally(()=>{
            setIndiceUpdate(-1)
            setReload(prev => ++prev)
        })
    }
    return (
        <>
            <TableContainer classes={{root: "!overflow-hidden"}} component="div" sx={{ maxHeight: 440, width: '100%', display: 'block' }}>
                <Table
                    stickyHeader
                    sx={{
                        [`& .${tableCellClasses.root}`]: {
                            borderBottom: 'none'
                        }
                    }}
                    className="border table-auto" 
                >
                    {/* mx-9 */}
                    <TableHead>
                        <TableRow>
                            <StyledTableHeader sortDirection={orderBy === 'fullName' ? order : false} sx={{ minWidth: 150 }}>
                                <TableSortLabel
                                    active={true}
                                    direction={orderBy === 'fullName' ? order : 'asc'}
                                    onClick={() => handleSort('fullName')}
                                >
                                    Nom et prénom
                                </TableSortLabel>
                            </StyledTableHeader>
                            <StyledTableHeader sortDirection={orderBy === 'email' ? order : false} sx={{ minWidth: 150 }}>
                                <TableSortLabel
                                    active={true}
                                    direction={orderBy === 'email' ? order : 'asc'}
                                    onClick={() => handleSort('email')}
                                >
                                    Email
                                </TableSortLabel>
                            </StyledTableHeader>
                            <StyledTableHeader sortDirection={orderBy === 'numero' ? order : false} sx={{ minWidth: 150 }}>
                                <TableSortLabel
                                    active={true}
                                    direction={orderBy === 'numero' ? order : 'asc'}
                                    onClick={() => handleSort('numero')}
                                >
                                    Téléphone
                                </TableSortLabel>
                            </StyledTableHeader>
                            <StyledTableHeader sortDirection={orderBy === 'mission' ? order : false} sx={{ minWidth: 150 }}>
                                <TableSortLabel
                                    active={true}
                                    direction={orderBy === 'mission' ? order : 'asc'}
                                    onClick={() => handleSort('mission')}
                                >
                                    Annulation de mission
                                </TableSortLabel>
                            </StyledTableHeader>
                            <StyledTableHeader sx={{ minWidth: 150 }}>
                                <TableSortLabel
                                >
                                    Libellé
                                </TableSortLabel>
                            </StyledTableHeader>
                            <StyledTableHeader sortDirection={orderBy === 'createdAt' ? order : false} sx={{ minWidth: 150 }}>
                                <TableSortLabel
                                    active={true}
                                    direction={orderBy === 'createdAt' ? order : 'asc'}
                                    onClick={() => handleSort('createdAt')}
                                >
                                    Créé le
                                </TableSortLabel>
                            </StyledTableHeader>
                            <StyledTableHeader sx={{ minWidth: 150 }}>Actions</StyledTableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map((row: User, i: number) => (
                            <StyledTableRow key={i}>
                                <TableCell className="border">
                                    <div className="whitespace-nowrap">{` ${row.lastname} ${row.firstname}`}</div>
                                </TableCell>
                                <TableCell className="border">{row.email}</TableCell>
                                <TableCell className="border">{row.numero}</TableCell>
                                <StyledTableHeader className="border">
                                    {indiceUpdate !== i && (
                                        <>
                                            {row.accountWarning}
                                            <EditIcon
                                                color="primary"
                                                onClick={() => {
                                                    setIndiceUpdate(i)
                                                    setUpdateAFaire(row.accountWarning)
                                                }}
                                                className="cursor-pointer"
                                            />
                                        </>
                                    )}
                                    {indiceUpdate === i &&(
                                        <>
                                            <Input
                                                type='number'
                                                value={updateAFaire}
                                                placeholder="Modifier warning"
                                                id="outlined-start-adornment"
                                                onChange={(e: any) => setUpdateAFaire(+e.target.value)}
                                                sx={{ m: 1, width: '25ch' }}
                                                inputProps={{ min: 1, max: 3 }}
                                            />
                                            <CheckCircleOutline
                                                className="cursor-pointer"
                                                onClick={() => {
                                                    handleUpdateWarning(row._id,updateAFaire)
                                                }}
                                            /> 
                                            <CancelOutlined className="cursor-pointer" onClick={() => setIndiceUpdate(-1)} />
                                        </>
                                    )}
                                    
                                </StyledTableHeader>
                                <TableCell className="border">{row.accountWarning === 1 ? 'Ce compte est bloqué pour une semaine' : row.accountWarning === 2 ? 'Ce compte est bloqué un mois' : 'Ce compte est bloqué indéfiniment' }</TableCell>
                                <TableCell className="border">{DateFormater(row.createdAt.toString())}</TableCell>
                                <TableCell className="border" >
                                    <LockOpenIcon
                                        style={{ display: 'block', margin: ' 0 auto' }}
                                        onClick={() => {
                                            setSelectedItem(row)
                                            setOpen(true)
                                        }}
                                    />
                                </TableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ display: 'flex', mt: 5 }}>
                <Grid container alignItems="center" justifyContent="end" gap={1}>
                    
                {users.length > 0 && (
                    <>
                    <Stack spacing={2}>
                        <Pagination
                            count={Math.ceil(users.length / rowsPerPage)}
                            page={page}
                            onChange={handleChangePage}
                            color="primary"
                            shape="rounded"
                        />
                    </Stack>
                        
                    <FormControl sx={{ m: 1, minWidth: 120, background: 'white' }} size="small">
                        <Select
                            value={rowsPerPage}
                            onChange={e => setRowsPerPage(+e.target.value)}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                        >
                            <MenuItem value={5}>5 / page</MenuItem>
                            <MenuItem value={10}>10 / page</MenuItem>
                            <MenuItem value={25}>25 / page</MenuItem>
                        </Select>
                    </FormControl>
                    </>
                )}
                {users.length === 0 && (<Typography>Aucun compte à afficher</Typography>)}
                </Grid>
            </Box>
            <ModaleValidationDeblocageComponent
                openModale={open}
                setOpen={setOpen}
                message={`Voulez-vous lever le blocage du compte de ${selectedItem?.lastname} ${selectedItem?.firstname}`}
                handleValidate={() => {
                    if (selectedItem) liftUserSuspension()
                }}
            />
            <Backdrop open={loading} sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}>
                <CircularProgress />
            </Backdrop>
        </>
    )
}

export default AccountBlockingComponent
